module.exports = __webpack_public_path__ + "static/media/4.Bending-Machine.56049e0f.webp";